module.exports = __webpack_public_path__ + "static/media/radienceDNAIntensiveCream.3d1cdfc1.png";